import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../store';
import { saveRegCard } from '../api';

const initialState = {
	signature: null,
	error: {
		submitSignature: null,
	},
	isPostComplete: false,
} as any;
export const submitSignature = createAsyncThunk<
	{
		result?: boolean;
		[key: string]: any;
	},
	{
		token: string;
		reservationId: number;
		confirmationNo: string;
		signature: Blob | File;
		propertyCode: string;
	}
>('Profile/SubmitSignature', async (signatureParam, thunkAPI) => {
	const { token, reservationId, confirmationNo, signature, propertyCode } =
		signatureParam;

	const response = await saveRegCard(
		token,
		reservationId,
		confirmationNo,
		signature,
		propertyCode
	);

	return response?.data;
});

export const submitSignature11 = createAsyncThunk<
	{
		result?: boolean;
		[key: string]: any;
	},
	{
		token: string;
		reservationId: number;
		confirmationNo: string;
		signature: string;
		propertyCode: string; //added new
	}
>('Profile/SubmitSignature', async (signatureParam, thunkAPI) => {
	const { token, reservationId, confirmationNo, signature, propertyCode } =
		signatureParam;
	const response = await saveRegCard(
		token,
		reservationId,
		confirmationNo,
		signature,
		propertyCode
	);
	return response?.data;
});

const signatureSlice = createSlice({
	name: 'signature',
	initialState,
	reducers: {
		setSignature: (state, action) => {
			state.signature = action.payload;
		},
		clearSignature: (state, _) => {
			state.signature = null;
		},
		resetPostComplete: (state) => {
			state.isPostComplete = false;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(submitSignature.fulfilled, (state, action) => {
			state.signature = action.meta.arg.signature;
			state.error.submitSignature = null;
			state.isPostComplete = action.payload?.result === true;
		});

		builder.addCase(submitSignature.rejected, (state, action) => {
			state.error.submitSignature = action?.error;
		});
	},
});

export const { setSignature, clearSignature, resetPostComplete } =
	signatureSlice.actions;
export const selectSignature = (state: RootState) => state.signature;

export default signatureSlice.reducer;
